import { render, staticRenderFns } from "./Cart.vue?vue&type=template&id=851f9fba"
import script from "./Cart.js?vue&type=script&lang=js&external"
export * from "./Cart.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports